/**
 * Promote third-party widget titles to a single <h1> on specific SEO pages.
 * Widgets (Yotpo / ReCharge) render asynchronously, so we observe the DOM.
 * Only the first matching element is ever promoted.
 */
(function () {
  var path = window.location.pathname.replace(/\/$/, '') || '/';

  var RULES = {
    '/pages/rewards': '.yotpo-wave-1 .yotpo-title',
    '/tools/recurring/login': '#ReCharge .rc_title-bar__title h4',
    '/tools/recurring/get-subscription-access':
      '.rc_layout__container .rc_title-bar__title h2',
  };

  var selector = RULES[path];
  if (!selector) return;

  var OBSERVE_MS = 20000;
  var PROMOTED_ATTR = 'data-seo-h1-promoted';

  function promoteToH1(el) {
    if (!el || el.tagName === 'H1') return;

    var h1 = document.createElement('h1');
    for (var i = 0; i < el.attributes.length; i++) {
      var attr = el.attributes[i];
      h1.setAttribute(attr.name, attr.value);
    }
    h1.innerHTML = el.innerHTML;
    h1.setAttribute(PROMOTED_ATTR, 'true');
    el.replaceWith(h1);
  }

  function tryPromote() {
    // Already promoted once — do not touch further matches
    // (e.g. after h4→h1 the selector would otherwise hit the next h4).
    if (document.querySelector('[' + PROMOTED_ATTR + '="true"]')) return;

    var el = document.querySelector(selector);
    if (!el || el.tagName === 'H1') return;

    promoteToH1(el);
  }

  tryPromote();

  var observer = new MutationObserver(tryPromote);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(function () {
    observer.disconnect();
  }, OBSERVE_MS);
})();
